import styled, { css } from 'styled-components'

export const Navbar = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 24rem 24rem auto;
    gap: ${theme.space['8']};
    justify-content: end;
  `,
)

export const DateTimeCell = styled.div`
  display: flex;
  flex-direction: column;
`

export const TotalCell = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.space['4']};
  `,
)
